module.exports = __webpack_public_path__ + "img/RTB_Logo_Stacked-Blue.68648a52.png";